import { CouponStatus, CouponType } from "./index";
import { dateFormatter } from "project-config/utils/date-formatter";
import { CouponList } from "./coupon-list";

export function getCouponTypeTag(value?: number) {
  return "coupon_desktop_coin";
}

export function getCouponTypeSubTitle(value?: number) {
  return "coupon_desktop_only";
}

export function getWayFilter(value: number) {
  const result = {
    1: "coupon_pages_get_way_member",
    2: "coupon_pages_get_way_member_recharge",
    3: "coupon_pages_get_way_new_user_recharge",
    4: "coupon_pages_get_way_coupon",
    9: "coupon_pages_get_way_register",
    10: "coupon_pages_get_way_complete",
    12: "coupon_pages_get_way_recharge",
    15: "coupon_pages_get_way_error",
    16: "coupon_pages_get_way_presenter",
    19: "coupon_pages_get_way_activity",
    20: "coupon_pages_get_way_agent",
    21: "coupon_pages_get_way_follow",
    23: "coupon_pages_get_way_test",
    25: "coupon_pages_get_way_mini",
    30: "coupon_pages_get_way_youth",
    31: "coupon_pages_get_way_youth_wechat",
    32: "coupon_pages_get_way_coupon_error",
    33: "coupon_pages_get_way_33",
    34: "coupon_pages_get_way_transfer",
    35: "coupon_pages_get_way_mainuser_out",
    36: "coupon_pages_get_way_subuser_out",
    37: "coupon_pages_get_way_offline",
    24: "coupon_pages_inviter_gift",
    41: "coupon_pages_get_way_gpu_qingyun_ali",
    42: "coupon_pages_get_way_gpu_qingyun_wechat",
    43: "coupon_pages_get_way_gpu_qingyun_offline",
    64: "coupon_pages_get_way_64",
    65: "coupon_pages_get_way_65",
  }[value];
  return result || "";
}

export function getPeriodTimeFilter(
  effectiveDate: number,
  expireDate: number,
  vaildTerm?: number,
  format?: string
) {
  const SD = dateFormatter(effectiveDate, format);
  const ED = dateFormatter(expireDate, format);
  return `${SD}~${ED}`.replace(/~/g, "~\n");
}

export function getCurrentCouponNum(
  currentTab: CouponType,
  status: CouponStatus
) {
  const filterResult = CouponList.filter((p) => p.type === currentTab);
  if (!filterResult.length) return 0;
  if (status === CouponStatus.All) return filterResult[0].data.length;
  return filterResult[0].data.filter((p) => !!p.isExpired === !!status).length;
}

export function getRemainingNumberDays(expireDate: number) {
  return Math.floor(
    (expireDate - new Date().getTime()) / (24 * 3600 * 1000)
  ).toString();
}
